export const addClassName = ({ selector, className }) => {
  const element = document.querySelector(selector);
  if (element) {
    const classNames = element.className.split(' ');
    if (classNames.indexOf(name) === -1) {
      element.className += ` ${className}`;
    }
  }
};
